// extracted by mini-css-extract-plugin
export default {"skeletonText":"SkeletonText_skeletonText__v0KlQ","pulse":"SkeletonText_pulse__DsadJ"};